import Glide from "@glidejs/glide";

if (document.getElementsByClassName('glide').length > 0) {

  new Glide(".glide", {
    type: "carousel",
    controls: true,
    perView: 3,
    rewind: true,
    autoplay: false,
    focusAt: "center",
    startAt: 0,
    gap: 16,
    breakpoints: {
      1330: {
        perView: 2,
        focusAt: 0,
				peek: 0,
      },
      985: {
        focusAt: "center",
        perView: 1,
        gap: 16,
        peek: 0,
      },
      560: {
        focusAt: "center",
        perView: 1,
        gap: 16,
        peek: 100,
      },
      495: {
        focusAt: "center",
        perView: 1,
        gap: 16,
        peek: 60,
      },
      395: {
        focusAt: "center",
        perView: 1,
        gap: 16,
        peek: 50,
      },
      380: {
        focusAt: "center",
        perView: 1,
        gap: 16,
        peek: 40,
      },
    },
  }).mount();

}
